import { Stack } from "@mui/material";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import { TextWrapper } from "./TextWrapper";
import { RateIndicator } from "../../../types/enums";
import { indicatorMapper, RateIndicatorIcon } from "../../ui/RateIndicatorIcon";
import React from "react";

export const TextCell = ({
  value,
  tooltip,
  minWidth,
  maxWidth,
  justifyContent = "flex-start",
  isHighlighted,
  indicator,
  is_hidden,
  indicatorChange,
  indicatorChangeAt,
  is_activated,
}: {
  value: string;
  tooltip?: string;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  isHighlighted?: boolean;
  indicator?: RateIndicator;
  is_hidden?: boolean;
  indicatorChange?: number;
  indicatorChangeAt?: string;
  is_activated?: boolean;
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      padding="0 16px"
      gap="8px"
    >
      <RateIndicatorIcon
        indicatorRate={indicator}
        indicatorChange={indicatorChange}
        indicatorChangeAt={indicatorChangeAt}
      />
      {is_hidden ? (
        <TextWrapper
          text={"Hidden Example (HME)."}
          isHighlighted={isHighlighted}
          is_activated={is_activated}
          style={{
            filter: "blur(4px)",
            borderRadius: "12px",
          }}
        />
      ) : (
        <EllipsisTooltip tooltip={tooltip} align="center">
          <TextWrapper
            isHighlighted={isHighlighted}
            is_activated={is_activated}
            text={value}
            style={{
              ...(indicator && {
                color: indicatorMapper[indicator].color,
              }),
            }}
          />
        </EllipsisTooltip>
      )}
    </Stack>
  );
};
